export default "__VITE_ASSET__B6unkmU5__"